import API from 'app/api';

const setMarketingReferrer = ({ referrer, sessionId }) =>
  API.Crapi.setMarketingReferrer({ referrer, session_id: sessionId });

export { setMarketingReferrer };
